export default "__VITE_ASSET__DmcB8d3M__"